import { render, staticRenderFns } from "./SimpleHorizontalIndicator.vue?vue&type=template&id=27840450&scoped=true"
import script from "./SimpleHorizontalIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleHorizontalIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleHorizontalIndicator.vue?vue&type=style&index=0&id=27840450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27840450",
  null
  
)

export default component.exports